import { useEffect, useState } from "react";
import { Order } from "../services";

export const useWagonTypes = (enabled, language) => {
  const [result, setResult] = useState(null);
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    if (!enabled) return;
    let active = true;
    setResult(null);
    Order.getWagonTypes(language)
      .then(({ data }) => {
        if (active) setResult({ language, options: data ?? [], failed: false });
      })
      .catch(() => {
        if (active) setResult({ language, options: [], failed: true });
      });
    return () => { active = false; };
  }, [enabled, language, attempt]);
  const current = result?.language === language ? result : null;
  return {
    options: enabled ? current?.options ?? [] : [],
    isLoading: enabled && !current,
    failed: enabled && Boolean(current?.failed),
    retry: () => setAttempt((value) => value + 1),
  };
};
